import { Component, Vue, Prop } from 'vue-property-decorator'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faFilter } from '@fortawesome/free-solid-svg-icons'
import { genId } from '@/helpers/gen-id'
import api from '@/helpers/fetch'

import Loader from '@/components/Loader/index.vue'
import UserCard from '@/components/UserCard/index.vue'

library.add(faFilter)

@Component({
	components: {
		Loader,
		UserCard,
	},
})
export default class TabContent extends Vue {
	@Prop({ type: String }) roleKey
	@Prop({ required: true, type: String }) roleName
	@Prop({
		type: Array,
		default: () => {
			return []
		},
	})
	usersList!: Array<any>

	loading = false
	remainingHeight = '0px'
	filter = {
		name: '',
	}

	calcRemainingHeight() {
		if (this.$refs.usersInputWrapper) {
			this.remainingHeight =
				window.innerHeight -
				(
					this.$refs.usersInputWrapper as HTMLElement
				).getBoundingClientRect().bottom -
				9 +
				'px'
		}
	}

	mounted() {
		this.load()

		window.addEventListener('resize', this.calcRemainingHeight)
	}

	beforeDestroy() {
		window.removeEventListener('resize', this.calcRemainingHeight)
	}

	async load() {
		this.loading = true
		const res = await api.get(
			'/api/permissions/roles/' + this.roleKey + '/users',
		)
		this.usersList.splice(0, this.usersList.length)
		this.usersList.push(
			...res.data.map((user) => {
				user.loading = false
				return user
			}),
		)
		this.loading = false
		this.$emit('users-loaded', this.roleKey)

		this.calcRemainingHeight()
	}

	get filteredUsers() {
		return this.usersList.filter(
			(user) =>
				user.name
					.toLowerCase()
					.indexOf(this.filter.name.toLowerCase()) >= 0,
		)
	}

	genId() {
		return genId()
	}
}
